import doorState from 'config/doorState';
import unloadSpeed from 'config/unloadSpeed';
import { monitorStat } from './constants';

export const filterDoorsAndSummary = (doors = [], summary = {}, direction) => {
  if (summary && Object.keys(summary).length) {
    summary[unloadSpeed.SLOW] = 0;
    summary[unloadSpeed.NORMAL] = 0;
    summary[unloadSpeed.FAST] = 0;
  }

  summary = doors.filter(d => d.direction === direction).reduce((summary, d) => {
    const inProgress = d.door_state === ({
      'LOAD': doorState.LOADING,
      'UNLOAD': doorState.UNLOADING
    })[direction];

    if (d.has_cam === 1 && inProgress) {
      summary[d.relative_speed] = (summary[d.relative_speed] || 0) + 1;
    }
    return summary;
  }, summary);

  const dirDoors = doors.filter(d => d.default_direction === direction)
    .map(d => {
      const digits = d.name.match(/\d+/);
      const nr = digits && parseInt(digits[0]);

      return {
        ...d,
        nr,
      };
    })
    .sort((a, b) => a.nr - b.nr);

  const stats = [
    { title: 'Not Started', color: '#232526', value: summary.not_started },
    { title: 'Slow', color: '#FAAD14', value: summary[unloadSpeed.SLOW] },
    { title: 'Normal', color: '#52C41A', value: summary[unloadSpeed.NORMAL] },
    { title: 'Fast', color: '#42B0D5', value: summary[unloadSpeed.FAST] },
    { title: 'Stopped', color: '#F5222D', value: summary.stopped },
    { title: 'Finished', color: '#1560AD', value: summary.complete },
    { title: 'Empty', color: '#828C94', value: summary.empty },
  ];

  return {
    stats: stats,
    doors: dirDoors,
  };
};

export const filterDoorsAndSummary2 = (doors = [], summary = {}, direction) => {
  if (summary && Object.keys(summary).length) {
    summary[unloadSpeed.SLOW] = 0;
    summary[unloadSpeed.NORMAL] = 0;
    summary[unloadSpeed.FAST] = 0;
  }

  summary = doors.filter(d => {
    if (direction) {
      return d.direction === direction
    }
    return true;
  }).reduce((summary, d) => {
    const inProgress = d.door_state === ({
      'LOAD': doorState.LOADING,
      'UNLOAD': doorState.UNLOADING
    })[direction];

    if (d.has_cam === 1 && inProgress) {
      summary[d.relative_speed] = (summary[d.relative_speed] || 0) + 1;
    }
    return summary;
  }, summary);

  const dirDoors = doors.filter(d => d.default_direction === direction)
    .map(d => {
      const digits = d.name.match(/\d+/);
      const nr = digits && parseInt(digits[0]);

      return {
        ...d,
        nr,
      };
    })
    .sort((a, b) => a.nr - b.nr);

  let stats = [];

  if (direction === 'UNLOAD') {
    stats = [
      { stat: monitorStat.NOT_STARTED, value: summary.not_started },
      { stat: monitorStat.SLOW, value: summary[unloadSpeed.SLOW] },
      { stat: monitorStat.NORMAL, value: summary[unloadSpeed.NORMAL] },
      { stat: monitorStat.FAST, value: summary[unloadSpeed.FAST] },
      { stat: monitorStat.STOPPED, value: summary.stopped },
      { stat: monitorStat.FINISHED, value: summary.complete },
    ];
  }

  if (direction === 'LOAD') {
    stats = [
      { stat: monitorStat.NOT_STARTED, value: summary.not_started },
      { stat: monitorStat.SLOW, value: summary[unloadSpeed.SLOW] },
      { stat: monitorStat.NORMAL, value: summary[unloadSpeed.NORMAL] },
      { stat: monitorStat.FAST, value: summary[unloadSpeed.FAST] },
      { stat: monitorStat.STOPPED, value: summary.stopped },
      { stat: monitorStat.FINISHED, value: summary.complete },
    ];
  }

  return {
    summary,
    stats: stats,
    doors: dirDoors,
  };
};

// export const groupInSplits = (arr, nrOfSplits) => {
//   const parts = Array.from(new Array(nrOfSplits).keys()).map(() => []);
//   arr.forEach((item, index) => {
//     parts[index % nrOfSplits].push(item);
//   });
//   return parts;
// };